import { render } from "./AddProjectDrawer.vue?vue&type=template&id=8d0f4c50&scoped=true"
import script from "./AddProjectDrawer.vue?vue&type=script&lang=js"
export * from "./AddProjectDrawer.vue?vue&type=script&lang=js"

import "./AddProjectDrawer.vue?vue&type=style&index=0&id=8d0f4c50&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0f4c50"]])

export default __exports__